(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin/user/register', {
            parent: 'admin/user',
            url: '/admin/crear-usuario',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'admin.register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'registerCtrl'
                }
            }
        });
    }
})();
